import React, { useEffect, useRef } from 'react';

export const usePerformance = (componentName) => {
  const renderStart = useRef(performance.now());

  useEffect(() => {
    const renderEnd = performance.now();
    const renderTime = renderEnd - renderStart.current;
    
    if (process.env.NODE_ENV === 'development') {
      console.log(`${componentName} render time: ${renderTime.toFixed(2)}ms`);
    }
    
    // Report to performance monitoring service in production
    //if (process.env.NODE_ENV === 'production' && renderTime > 100) {
      // Only report slow renders
      //console.warn(`Slow render detected in ${componentName}: ${renderTime.toFixed(2)}ms`);
    //}
  });

  return {
    markStart: (label) => performance.mark(`${componentName}-${label}-start`),
    markEnd: (label) => {
      performance.mark(`${componentName}-${label}-end`);
      performance.measure(
        `${componentName}-${label}`,
        `${componentName}-${label}-start`,
        `${componentName}-${label}-end`
      );
    }
  };
};